export default __webpack_public_path__ + "static/media/hp_slide4.f21302ac.jpg";